import React, { useState, useEffect } from 'react';
import { Undo2, Trash2, Upload } from 'lucide-react';
import { getFirestore, collection, getDocs, deleteDoc, doc } from 'firebase/firestore';
import { app } from '../firebase';

const db = getFirestore(app);

const PreviousTournaments = ({ onLoadTournament, onBack, user }) => {
    const [tournaments, setTournaments] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const fetchTournaments = async () => {
            if (user) {
                setLoading(true);
                const querySnapshot = await getDocs(collection(db, 'users', user.uid, 'archivedTournaments'));
                const fetchedTournaments = querySnapshot.docs.map(doc => doc.data());
                setTournaments(fetchedTournaments);
                setLoading(false);
            }
        };

        fetchTournaments();
    }, [user]);

    const handleDelete = async (timestamp) => {
        if (user) {
            // eslint-disable-next-line no-restricted-globals
            if (window.confirm("Are you sure you want to delete this tournament? This action cannot be undone.")) {
                try {
                    await deleteDoc(doc(db, 'users', user.uid, 'archivedTournaments', timestamp));
                    const updatedTournaments = tournaments.filter(t => t.timestamp !== timestamp);
                    setTournaments(updatedTournaments);
                } catch (error) {
                    console.error("Error deleting tournament: ", error);
                }
            }
        }
    };

    if (loading) {
        return <div className="p-4 bg-slate-950 text-slate-100 min-h-screen flex justify-center items-center">Loading previous tournaments...</div>;
    }

    return (
        <div className="p-4 bg-slate-950 text-slate-100 min-h-screen">
            <div className="max-w-2xl mx-auto">
                <h2 className="text-2xl font-bold mb-6 text-center text-slate-300">Torneios Anteriores</h2>
                {tournaments.length > 0 ? (
                    <ul className="space-y-4">
                        {tournaments.sort((a, b) => new Date(b.timestamp) - new Date(a.timestamp)).map((tournament) => (
                            <li key={tournament.timestamp} className="bg-slate-900/80 p-4 rounded-xl shadow-lg border border-slate-800 flex justify-between items-center transition-all hover:border-slate-700">
                                <div>
                                    <p className="font-semibold text-lg text-slate-200">{tournament.name}</p>
                                    <p className="text-sm text-slate-400">
                                        {tournament.players.length} jogadores, {tournament.matches.length} partidas
                                    </p>
                                    <p className="text-xs text-slate-500 mt-1">
                                        Salvo em: {new Date(tournament.timestamp).toLocaleString()}
                                    </p>
                                </div>
                                <div className="flex items-center space-x-3">
                                    <button
                                        onClick={() => onLoadTournament(tournament)}
                                        className="p-2.5 bg-sky-600/20 hover:bg-sky-500/30 rounded-full text-sky-400 transition-colors"
                                        title="Carregar Torneio"
                                    >
                                        <Upload className="w-5 h-5" />
                                    </button>
                                    <button
                                        onClick={() => handleDelete(tournament.timestamp)}
                                        className="p-2.5 bg-rose-600/20 hover:bg-rose-500/30 rounded-full text-rose-400 transition-colors"
                                        title="Excluir Torneio"
                                    >
                                        <Trash2 className="w-5 h-5" />
                                    </button>
                                </div>
                            </li>
                        ))}
                    </ul>
                ) : (
                    <p className="text-center text-slate-400 py-10">Nenhum torneio anterior encontrado.</p>
                )}
                <div className="mt-8 text-center">
                    <button
                        onClick={onBack}
                        className="bg-slate-800 hover:bg-slate-700 text-slate-200 font-bold py-2 px-6 rounded-lg transition-colors flex items-center gap-2 mx-auto"
                    >
                        <Undo2 className="w-5 h-5" />
                        Voltar
                    </button>
                </div>
            </div>
        </div>
    );
};

export default PreviousTournaments;
